import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, Suspense as _Suspense, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-left-container d-flex align-center" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "header-right-container d-flex align-center" }
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "connection-warning",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ConnectStatus = _resolveComponent("ConnectStatus")!
  const _component_LocaleLink = _resolveComponent("LocaleLink")!
  const _component_SpoilerEye = _resolveComponent("SpoilerEye")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_LanguageSuggestion = _resolveComponent("LanguageSuggestion")!
  const _component_AuthModal = _resolveComponent("AuthModal")!
  const _component_WelcomeModal = _resolveComponent("WelcomeModal")!
  const _component_CredentialsModal = _resolveComponent("CredentialsModal")!
  const _component_InfoSnackbar = _resolveComponent("InfoSnackbar")!
  const _component_AchievementPopupsContainer = _resolveComponent("AchievementPopupsContainer")!
  const _component_Version = _resolveComponent("Version")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_RouterLink, {
          class: "home-link",
          to: _ctx.homePath,
          "aria-label": _ctx.$t('menu.home')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              class: "home-icon",
              size: "20",
              icon: "fa:fa-solid fa-house",
              "aria-hidden": "true"
            })
          ]),
          _: 1
        }, 8, ["to", "aria-label"]),
        (_ctx.currentRoute === 'room')
          ? (_openBlock(), _createBlock(_component_ConnectStatus, {
              key: 0,
              class: "connect-status"
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("nav", {
        class: "header-navigation",
        "aria-label": _ctx.$t('menu.menu')
      }, [
        _createVNode(_component_LocaleLink, {
          to: { name: 'community_group' },
          class: _normalizeClass({ active: _ctx.inSection('/community/') })
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('playerBoards.findCompany')), 1)
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_LocaleLink, {
          class: _normalizeClass(["desktop-navigation", { active: _ctx.inSection('/wiki/') }]),
          to: { name: 'wiki' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('menu.rulesRoles')), 1)
          ]),
          _: 1
        }, 8, ["class"])
      ], 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.currentRoute === 'room')
          ? (_openBlock(), _createBlock(_component_SpoilerEye, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "header-account desktop-navigation",
          "aria-label": _ctx.$t(_ctx.$store.state.profile ? 'menu.myProfile' : 'menu.signIn'),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.profileClick && _ctx.profileClick(...args)))
        }, [
          (_ctx.$store.state.profile)
            ? (_openBlock(), _createBlock(_component_Avatar, {
                key: 0,
                avatarID: _ctx.$store.state.profile.avatar,
                alt: ""
              }, null, 8, ["avatarID"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('menu.signIn')), 1))
        ], 8, _hoisted_5),
        _createVNode(_component_Menu, { onProfileClick: _ctx.profileClick }, null, 8, ["onProfileClick"])
      ])
    ]),
    (_ctx.$store.state.connect === false)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t('onlineStatus.error')), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_RouterView, null, {
      default: _withCtx(({ Component }) => [
        Component
          ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
              fallback: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('mainPage.loading')), 1)
              ]),
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { class: "page" }))
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_LanguageSuggestion),
    (_ctx.authRequested)
      ? (_openBlock(), _createBlock(_component_AuthModal, {
          key: 1,
          modelValue: _ctx.authOpen,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.authOpen) = $event)),
          continuation: _ctx.authContinuation,
          onRegistered: _cache[2] || (_cache[2] = ($event: any) => (_ctx.welcomeOpen = true))
        }, null, 8, ["modelValue", "continuation"]))
      : _createCommentVNode("", true),
    (_ctx.welcomeOpen && _ctx.$store.state.profile)
      ? (_openBlock(), _createBlock(_component_WelcomeModal, {
          key: 2,
          modelValue: _ctx.welcomeOpen,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.welcomeOpen) = $event))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.credentialsRequested)
      ? (_openBlock(), _createBlock(_component_CredentialsModal, {
          key: 3,
          modelValue: _ctx.credentialsOpen,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.credentialsOpen) = $event)),
          mode: _ctx.credentialsMode
        }, null, 8, ["modelValue", "mode"]))
      : _createCommentVNode("", true),
    _createVNode(_component_InfoSnackbar),
    _createVNode(_component_AchievementPopupsContainer),
    _createVNode(_component_Version, { class: "version" })
  ], 64))
}